import { InputContainer } from "@components/InputContainer";
import { SelectPaymentSource } from "@components/donate/DonateV3/PaymentProcess/components/SelectPaymentSource";
import { DonateFormContext } from "@components/donate/DonateV3/PaymentProcess/useDonateFormContext";
import {
  DonateFormType,
  DonateModalAction,
} from "@components/donate/DonateV3/types";
import { Big } from "big.js";
import { useState } from "react";
import { UseFormSetError } from "react-hook-form";

import {
  PaymentSourceResponse as PaymentSource,
  NonprofitResponse,
} from "@every.org/common/src/codecs/entities";
import { Location } from "@every.org/common/src/codecs/location";
import {
  DonationFrequency,
  PaymentSourceType,
} from "@every.org/common/src/entity/types";

export const PaymentMethodPicker = ({
  amountToCharge,
  amountBig,
  tipAmount,
  creditAmount,
  renewablePaymentSourceRequired,
  isInternational,
  isGiftCardPurchase,
  paymentSources,
  setPaymentSources,
  onChange,
  creditsOnly,
  donateAction,
  selectedPaymentSource,
  paymentSourceType,
  firstName,
  lastName,
  email,
  clearFormError,
  setFormError,
  nonprofit,
  frequency,
  createNewCardPaymentIntentRef,
  location,
  isAddressRequired,
  onAddingCard,
}: {
  paymentSourceType: PaymentSourceType;
  amountToCharge: Big;
  amountBig: Big;
  tipAmount: Big;
  creditAmount: Big;
  creditsOnly: boolean;
  donateAction?: DonateModalAction;
  renewablePaymentSourceRequired: boolean;
  isInternational: boolean;
  isGiftCardPurchase: boolean;
  paymentSources?: DonateFormContext["paymentSources"];
  setPaymentSources: DonateFormContext["setPaymentSources"];
  onChange: (selectedSource?: PaymentSource) => void;
  selectedPaymentSource?: PaymentSource;
  firstName?: string;
  lastName?: string;
  email?: string;
  clearFormError?: () => void;
  setFormError?: UseFormSetError<DonateFormType>;
  nonprofit?: NonprofitResponse;
  frequency?: DonationFrequency;
  createNewCardPaymentIntentRef: DonateFormContext["createNewCardPaymentIntentRef"];
  location?: Location;
  isAddressRequired?: boolean;
  onAddingCard?: (isAddingCard: boolean) => void;
}) => {
  // TODO use error message
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [errorMessage, setErrorMessage] = useState<string>();

  return (
    <InputContainer data-tname="selectPaymentSource" collapseDescriptionSpace>
      <SelectPaymentSource
        selectedPaymentSourceType={paymentSourceType}
        paymentSources={paymentSources}
        setPaymentSources={setPaymentSources}
        selectedPaymentSource={selectedPaymentSource || undefined}
        setSelectedPaymentSource={onChange}
        amountToCharge={amountToCharge}
        amountBig={amountBig}
        tipAmount={tipAmount}
        creditAmount={creditAmount}
        creditsOnly={creditsOnly}
        donateAction={donateAction}
        renewablePaymentSourceRequired={renewablePaymentSourceRequired}
        setErrorMessage={setErrorMessage}
        // disallowAddingType={
        //   isInternational
        //     ? new Set<PaymentSourceType>([PaymentSourceType.ACH_DEBIT])
        //     : undefined
        // }
        isGiftCardPurchase={isGiftCardPurchase}
        firstName={firstName}
        lastName={lastName}
        email={email}
        clearFormError={clearFormError}
        setFormError={setFormError}
        nonprofit={nonprofit}
        frequency={frequency}
        createNewCardPaymentIntentRef={createNewCardPaymentIntentRef}
        location={location}
        isAddressRequired={isAddressRequired}
        onAddingCard={onAddingCard}
      />
    </InputContainer>
  );
};
